module.exports = __webpack_public_path__ + "media/images/markitup/italic-fca8af7918d79e4716235e6232a4ada5.png";